import styled from 'styled-components';
import StyledButton from './StyledButton';

interface StyledChatToggleButtonProps {
  $backgroundColor: string;
  $chatOpened: boolean;
}

const StyledChatToggleButton = styled(StyledButton)<StyledChatToggleButtonProps>`
  height: ${(props) => props.$chatOpened ? '40px' : '80px'};
  width: ${(props) => props.$chatOpened ? '40px' : '80px'};
  background-color: ${(props) => props.$backgroundColor};
  border-radius: 50%;
  box-shadow: 0px 0px 20px rgb(0 0 0 / 20%);
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-end;
  flex-shrink: 0;

  .svg-close-chat {
    scale: 0.7;
    margin-top: 4px;
  }

  .svg-open-chat {
    margin-top: 6px;
  }
`;

export default StyledChatToggleButton;